module.exports = __webpack_public_path__ + "img/wrapper_bg.64b59a9.png";